import useCashierStore from "@casino/client/hooks/useCashierStore";
import COUNTRY_CODE from "@workspace/casino_config/cookies/COUNTRY_CODE";
import { getCookie } from "@workspace/cookies/browser";
import useCurrencyConfig from "../../currency/useCurrencyConfig";
import useRouter from "../../router/useRouter";
import useFeature from "../useFeature";

type Args = {
  cashierPath?: string;
};

type ReturnProps = {
  link: string;
  onClick?: () => void;
  open?: () => void;
};

const useCashierLink = ({ cashierPath = "home" }: Args = {}): ReturnProps => {
  const { type, name } = useCurrencyConfig();

  const { asPath } = useRouter();
  const { setOpen } = useCashierStore();
  const isWalletLandingPageEnabled = useFeature("isWalletLandingPageEnabled");
  const countryCode = getCookie(COUNTRY_CODE);
  const cashierLink = asPath.includes("?modal=menu")
    ? `${asPath}&c=${cashierPath}`
    : `${asPath}?c=${cashierPath}`;

  const getDefaultPath = () => {
    const isPathDeposit = cashierPath === "deposit";
    if (isPathDeposit && type === "coin") {
      return `${cashierPath}-${name}`;
    }
    if (isWalletLandingPageEnabled || countryCode === "TR") {
      return "wallet_landing";
    }
    return "home";
  };

  const isPathDepositOptions = cashierPath.startsWith("deposit_options");
  const cashierPage = isPathDepositOptions ? cashierPath : getDefaultPath();
  return {
    link: cashierLink,
    onClick: () => {
      setCashierParam(cashierPage);
      setOpen(true);
    },
    open: () => {
      setCashierParam(cashierPath);
      setOpen(true);
    },
  };
};

export const setCashierParam = (value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set("c", value);
  window.history.replaceState(window.history.state, "", url);
};

export default useCashierLink;
